// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const capsakid: PokeData = {
  "id": 951,
  "name": "capsakid",
  "height": 3,
  "weight": 30,
  "base_experience": 61,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "headbutt",
    "leer",
    "bite",
    "growth",
    "razor-leaf",
    "solar-beam",
    "sunny-day",
    "crunch",
    "bullet-seed",
    "seed-bomb",
    "zen-headbutt",
    "leafage"
  ],
  "moves": [
    "headbutt",
    "leer",
    "bite",
    "razor-leaf",
    "solar-beam",
    "sunny-day",
    "crunch",
    "bullet-seed",
    "zen-headbutt",
    "overgrowth",
    "grassy-terrain",
    "aromatherapy",
    "wood-hammer"
  ],
  "evolution_chain": {
    "id": 498,
    "item": null,
    "species": [
      {
        "name": "capsakid",
        "order": 938,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "scovillain",
        "order": 939,
        "types": [
          PokeType.GRASS,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 951,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 50,
    "ability_power": 62
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
